import { CommandGroup, CommandItem, CommandList } from '@ui/components/base/command';
import type { TemplateTagGroup } from '@ui/components/editor/templateTagUtils';

const UNCATEGORIZED_GROUP_KEY = 'uncategorized';

interface TemplateTagCommandListProps {
  label: string;
  groups: TemplateTagGroup[];
  onSelect: (token: string) => void;
}

const TemplateTagCommandList = ({ label, groups, onSelect }: TemplateTagCommandListProps) => (
  <CommandList label={label}>
    {groups.map((group) => (
      <CommandGroup key={group.category ?? UNCATEGORIZED_GROUP_KEY} heading={group.category}>
        {group.tags.map((tag) => (
          <CommandItem key={tag.token} value={tag.token} title={tag.token} onSelect={() => onSelect(tag.token)}>
            {tag.label}
          </CommandItem>
        ))}
      </CommandGroup>
    ))}
  </CommandList>
);

export { TemplateTagCommandList };
